import React, { Fragment, useEffect, useState } from 'react';
import { UserProfileProps, useUserProfile } from '../../../../../providers/user-provider';
import QuickLink from '../../../../basic/quickLink';
import { TyLink } from '../../../../../types';
import { checkActiveUrl } from '../../../../../utils/browserUtils';
import { buildAnalytics, DataAnalyticsLocations, DataAnalyticsTypes } from '../../../../basic/analytics';
import Button from '../../../../basic/button';
import { useTranslator } from '../../locales-provider';

interface NavLinksProps {
    navLinks: TyLink[];
}
export default function MenuLinks({ navLinks }: NavLinksProps) {

    const { userProfile } = useUserProfile();
    const [relativepath, setRelativePath] = useState<string>();
    const url = new URL(window.location.href);
    const locales = useTranslator('global');

    useEffect(() => {
        setRelativePath(url.pathname);
    }, [url]);

    return (
        <Fragment>
            {navLinks && navLinks.map((link: any, idx) => {
                if (link.showOnlyAfterLogin && !userProfile) { return; }
                return (
                    <div className="flex items-center justify-center lg:gap-sm xl:gap-2md p-0" key={`menulinks-${idx}`} data-testid="menuLinks" >
                        <QuickLink href={link?.href} isExternal={link.isexternallink} className={`text-md text-white
                        ${checkActiveUrl(link?.href, relativepath) ? 'border-sky-200 border-b-4 border-separate' : 'hover:border-sky-200 border-b-2 border-transparent'}`} 
                            dataAnalytics={buildAnalytics(DataAnalyticsLocations.Menu, DataAnalyticsTypes.Link, [DataAnalyticsLocations.Page, DataAnalyticsLocations.Header])}
                            aria-label={`${link?.label} ${link.isexternallink ? locales?.['aria.label.newTab'] : ''}`}>
                                {link?.label}
                        </QuickLink>

                    </div>
                )
            })}
        </Fragment>
    );
}
